<template>
    <div class="login-box">
        <img src="./../assets/linenazi_icon.png" alt="">
        <el-form status-icon ref="form" label-width="100px" class="login-form">
            <el-form-item label="管理员账号" prop="username">
                <el-input type="text" v-model="form.username" autocomplete="off" placeholder="填写灵能纳茨管理员账号"></el-input>
            </el-form-item>
            <el-form-item label="管理员密码" prop="password">
                <el-input type="password" v-model="form.password" autocomplete="off" placeholder="填写灵能纳茨管理员密码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" class="stretch-button" @click="handleLogin">登录灵能纳茨管理员端</el-button>
                <el-button @click="forgetPassword">忘记密码</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Api from '@/apis';
export default {
    data() {
        return {
            form: {
                id: '',
                username: '',
                password: ''
            }
        };
    },
    methods: {
        handleLogin() {
            Api.login(this.form).then(res => {
                if (res.data.code == 200) {
                    this.$message({ message: res.data.message, type: 'success' });
                    sessionStorage.setItem("license", JSON.stringify(res.data.data))
                    this.$router.replace('/manage/instance')
                } else {
                    this.$message({ message: res.data.message, type: 'error' });
                }
            }).catch(() => {
                Api.feedback(this)
            })
        },
        forgetPassword() {
            this.$alert('联系预醒网络官方邮箱：edgehacker@willwaking.com', '忘记密码解决方案', {
                confirmButtonText: '确定'
            })
        }
    }
}
</script>

<style scoped>
.login-box {
    background-color: rgba(255, 255, 255, 0.5);
    box-shadow: 0 2px 8px 0 rgb(99 99 99 / 0.1);
    border-radius: 5px;
    height: 420px;
    width: 500px;
}

img {
    width: 100px;
    height: 100px;
    display: flex;
    cursor: pointer;
    border-radius: 5px;
    margin: 40px auto;
}

.login-form {
    margin: 20px;
}

.el-form-item {
    margin-bottom: 40px;
}
</style>